'use strict';

import angular from 'angular';

export default class MemFeeFormCtrl {
  model = {
    name: '',
    isActive: true
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, MemFeeSvc,
    MemTypeSvc, GroupSvc, GroupAuthSvc, DatetimeSvc) {
    var groupId = $stateParams.groupId;
    this.groupId = groupId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.MemFeeSvc = MemFeeSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;

    // fee types
    this.feeTypes = [
      // dues = annual fees - priced @ time of membership start
      {type: 'dues', name: 'Membership Dues'},
      {type: 'new', name: 'New Member'},
      {type: 'transfer', name: 'Transfer Member'},
      {type: 'reactivate', name: 'Reactivate Member'},
      // {type: 'fee', name: 'Fee'} // annual fees - priced @ time of payment
      // {type: 'late', name: 'Late Fee'} // overall late - non-zero balance
    ];

    // dues calc options
    this.calcOptions = [
      {type: 'first', name: 'First'},
      {type: 'last', name: 'Last'},
      {type: 'min', name: 'Minimum'},
      {type: 'max', name: 'Maximum'},
      {type: 'sum', name: 'Sum'}
    ];

    this.isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(this.isCreate) {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'memberFee', 'C');

      this.submit = this.createMemberFee;
      that.headerText = 'New Member Dues/Fee';
      that.submitText = 'Create Member Dues/Fee';
      GroupSvc.getTimePeriods({groupId}).$promise.then(function(tp) {
        that.timePeriods = tp;
      });
      this.cancelSref = 'group.view.settings.memberFee.list';

    // edit
    } else {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'memberFee', 'U');

      this.submit = this.updateMemberFee;
      var mfId = $stateParams.mfId;
      that.mfId = mfId;
      that.headerText = 'Edit Member Dues/Fee';
      that.submitText = 'Update Member Dues/Fee';
      this.MemFeeSvc.get({groupId, id: mfId}).$promise
        .then(function(mf) {
        // ensure amount dates are in proper format for update
          var amountTypesArray = ['amounts', 'adjustments'];
          for(var i in amountTypesArray) {
            var at = amountTypesArray[i];
            mf[at].map(DatetimeSvc.getFormDateRange);
          }

          that.model = angular.copy(mf);
          that.display = mf;
        });
      this.cancelSref = 'group.view.settings.memberFee.list';
    }
  }

  createMemberFee() {
    var that = this;
    that.LoaderSvc.start();
    var model = that.model;
    model.toGroup = {id: Number(that.groupId)};
    that.MemFeeSvc.create({groupId: that.groupId}, this.model).$promise
      .then(function(mf) {
        that.LoaderSvc.stopSuccess('Member Dues/Fee Created');
        that.$state.go('group.view.settings.memberFee.view', {mfId: mf.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateMemberFee() {
    var that = this;
    that.LoaderSvc.start();
    // remove rels that cannot be edited
    var model = this.model;
    delete model.toGroup;
    delete model.mfTimePer;
    this.MemFeeSvc
      .update({groupId: that.groupId, id: that.mfId}, model).$promise
      .then(function() {
        that.$state
          .go('group.view.settings.memberFee.list', {mfId: that.mfId});
        that.LoaderSvc.stopSuccess('Member Dues/Fee Updated');
      })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

MemFeeFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'MemFeeSvc',
  'MemTypeSvc',
  'GroupSvc',
  'GroupAuthSvc',
  'DatetimeSvc'
];
